import * as effects from './effects'

export default {
  effects,
}
